import studio1 from './studio1.jpg';
import studio2 from './studio2.jpg';
import studio3 from './studio3.jpg';
import studio4 from './studio4.jpg';
import studio5 from './studio5.jpg';
import studio6 from './studio6.jpg';

export const studioImages: string[] = [
    studio1,
    studio2,
    studio3,
    studio4,
    studio5,
    studio6,
];
